/**
 * Clears form upon submission.
 *
 * Usage:
 * = form_with model: message, data: { controller: "forms--clear-form", action: "turbo:submit-end->forms--clear-form#clear" }
 *
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static get targets() {
    return ["focusElement"];
  }

  clear() {
    this.element.reset();

    // Clear any error messages
    this.element.querySelectorAll(".invalid-feedback").forEach((e) => e.remove());

    if (this.hasFocusElementTarget) {
      this.focusElementTarget.focus();
    }
  }
}
